import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import createJobStatusFilterItems from "@/types/requests/createJobStatusFilterItems"
import createJobStatusSetting from "@/types/requests/createJobStatusSetting"
import DropDownButton from  "@/components/Common/DropDownButton.vue"
import FileUploadModal from "@/components/Files/UploadModal.vue"
import { useAuth } from "@/services/user/Auth0UserProvider"
import Api from "@/services/api/ApiServiceFabrick";
import { ref, Ref, computed } from 'vue'
import i18n from '@/lang/i18n'

type ItemsType = {
  csvImport: string,
  csvExport: string,
}

type authoritiesType = {
  csvImport: boolean
  csvExport: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UpsertCsvButtons',
  props: {
    title: {},
    items: { default: () => {
      return {
        csvImport: i18n.global.t("pages.common.button.csvUpsertImport"),
        csvExport: i18n.global.t("pages.common.button.csvUpsertExport")
      }
    } },
    importTitle: {},
    exportType: {},
    importType: {},
    operationOfficeId: {},
    settings: {},
    filterItems: {},
    trips: {},
    getList: {},
    authorities: {},
    elementId: {},
    addRequestParams: {},
    btnClass: { default: "exec-btn mt-0 ml-1" },
    dropDownStyle: { default: "" },
    isDisabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const { loginWithRedirect } = useAuth();
const exportModalstate: Ref<boolean> = ref(false)
const importModalstate: Ref<boolean> = ref(false)
const downloading: Ref<boolean> = ref(false)

const dropDownItems = computed(() => {
  const filteredItems = {} as ItemsType
  if (props.authorities.csvImport) {
    filteredItems.csvImport = props.items.csvImport
  }
  if (props.authorities.csvExport) {
    filteredItems.csvExport = props.items.csvExport
  }
  return filteredItems
})

function selectCsvItem(key: string) {
  exportModalstate.value = false;
  importModalstate.value = false;
  if (key.indexOf('Export') == -1) return importModalstate.value = true;
  return downloadFile()
}

function downloadFile() {
  downloading.value = true;

  let params = {
    operation_office_id: props.operationOfficeId ?? null,
    type: props.exportType,
    settings: props.settings ?? null,
    filter_items: props.filterItems ?? null,
    trips: props.trips ?? [],
  }
  if (props.addRequestParams) params = props.addRequestParams(params)

  Api().createJobStatus(params).then((data) => {
    pollingJobStatus(data.id)
  }).catch((error) => {
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({ appState: { targetUrl: location.pathname } })
        break
      case 403:
        location.reload()
        break
      case 422:
    }
    downloading.value = false
  })
}

function pollingJobStatus(id: number) {
  const interval = setInterval(() => {
    Api().getJobStatus(id).then((res) => {
      if (res.status == "completed") {
        download(res.file_path)
        clearInterval(interval)
      }
      if (res.status == "failed") {
        alert(res?.output_contents?.message)
        clearInterval(interval)
        downloading.value = false
      }
    })
  }, 3000)
}

function download(path: string) {
  if (!path) return;

  Api().fileDownload(path)
  downloading.value = false
}

function inactivateModalState(isReacquire: boolean) {
  importModalstate.value = false;
  if (isReacquire) props.getList()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DropDownButton, {
      btnClass: props.btnClass,
      dropDownStyle: props.dropDownStyle,
      title: props.title,
      items: dropDownItems.value,
      isLoading: downloading.value,
      elementId: props.elementId,
      isDisabled: props.isDisabled,
      onSelectDropDownItem: selectCsvItem
    }, null, 8, ["btnClass", "dropDownStyle", "title", "items", "isLoading", "elementId", "isDisabled"]),
    _createVNode(FileUploadModal, {
      modalState: importModalstate.value,
      title: props.importTitle,
      uploadBtnClass: "exec-btn mt-0 ml-1",
      closeBtnClass: "mt-0",
      type: props.importType,
      notes: _ctx.$t('pages.common.messages.csvUpsertModalMessage'),
      onCloseModal: inactivateModalState
    }, null, 8, ["modalState", "title", "type", "notes"])
  ], 64))
}
}

})